import { render, staticRenderFns } from "./AddVideoModal.vue?vue&type=template&id=461a90dc&"
import script from "./AddVideoModal.vue?vue&type=script&lang=js&"
export * from "./AddVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports